module.exports = __webpack_public_path__ + "static/media/remove.b511a520.svg";